import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "CreditRatingView" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
